/* VAIRE on Shopify: rebinds Store.cart onto the real Shopify AJAX Cart API.
   Same method signatures the whole UI already uses; localStorage is gone. */
(function () {
  'use strict';
  var S = window.Store;
  if (!S) return;
  var lines = []; /* mirror of Shopify cart */
  var gift = {
    handle: '10pcs-eye-makeup-brushes-set-eyeshadow-blending-angled-brow-travel-bag-upgraded-eye-shadow-brush-set-professional-shading-defining-cruelty-free-vegan-for-beginner-makeup-artist-recommendation',
    variantId: 46146624159778,
    threshold: 120
  };
  var reconcilingGift = false;

  function variantIdFor(id, shade) {
    var p = S.byId(id); if (!p) return null;
    if (p.shades && shade != null && p.shades[shade]) return p.shades[shade].variantId;
    return (p.variantIds && p.variantIds[0]) || null;
  }
  function shadeForVariant(p, variantId) {
    if (!p.shades) return null;
    for (var i = 0; i < p.shades.length; i++) if (p.shades[i].variantId === variantId) return i;
    return null;
  }
  function syncFrom(cart) {
    lines = (cart.items || []).map(function (it) {
      var p = (window.VAIRE_PRODUCTS || []).filter(function (x) { return x.id === it.handle; })[0];
      var properties = it.properties || {};
      return {
        id: it.handle,
        shade: p ? shadeForVariant(p, it.variant_id) : null,
        qty: it.quantity,
        key: it.key,
        variantId: it.variant_id,
        properties: properties,
        isGift: properties._vaire_gift === '120',
        linePrice: it.final_line_price / 100,
        originalLinePrice: it.original_line_price / 100
      };
    });
    document.dispatchEvent(new CustomEvent('vaire:cart-synced'));
  }
  function merchandiseSubtotal() {
    return lines.filter(function (i) { return !i.isGift; })
      .reduce(function (a, i) { return a + i.originalLinePrice; }, 0);
  }
  function request(url, body) {
    return fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().catch(function () { return {}; }).then(function (e) {
        var detail = e.description || e.message || e.status || JSON.stringify(e) || 'Cart update failed';
        throw new Error('Cart ' + r.status + ': ' + detail);
      });
      return r.json();
    });
  }
  function ajaxRoute(name, fallback) {
    var url = (window.VAIRE_ROUTES || {})[name] || fallback;
    return /\.js(?:\?|$)/.test(url) ? url : url + '.js';
  }
  function reconcileGift() {
    if (reconcilingGift) return Promise.resolve();
    var giftLines = lines.filter(function (i) { return i.isGift; });
    var qualifies = merchandiseSubtotal() >= gift.threshold;
    var change = null;
    if (qualifies && !giftLines.length) {
      change = request(ajaxRoute('cartAdd', '/cart/add.js'), {
        id: gift.variantId, quantity: 1, properties: { _vaire_gift: '120' }
      });
    } else if (qualifies && giftLines[0].qty !== 1) {
      change = request(ajaxRoute('cartChange', '/cart/change.js'), { id: giftLines[0].key, quantity: 1 });
    } else if (!qualifies && giftLines.length) {
      change = Promise.all(giftLines.map(function (line) {
        return request(ajaxRoute('cartChange', '/cart/change.js'), { id: line.key, quantity: 0 });
      }));
    }
    if (!change) return Promise.resolve();
    reconcilingGift = true;
    return change.then(function () { return refresh(true); })
      .catch(function () { document.dispatchEvent(new CustomEvent('vaire:gift-error')); })
      .finally(function () { reconcilingGift = false; });
  }
  function refresh(skipGiftCheck) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      syncFrom(cart);
      return skipGiftCheck ? cart : reconcileGift().then(function () { return cart; });
    });
  }

  S.cart.items = function () { return lines.slice(); };
  S.cart.count = function () { return lines.reduce(function (a, i) { return a + i.qty; }, 0); };
  S.cart.subtotal = function () { return lines.reduce(function (a, i) { return a + i.linePrice; }, 0); };
  S.cart.merchandiseSubtotal = merchandiseSubtotal;
  S.cart.giftQualified = function () { return merchandiseSubtotal() >= gift.threshold; };
  S.cart.hasGift = function () { return lines.some(function (i) { return i.isGift; }); };
  S.cart.add = function (id, shade, qty) {
    var v = variantIdFor(id, shade); if (!v) return;
    return request(ajaxRoute('cartAdd', '/cart/add.js'), { id: v, quantity: qty || 1 }).then(function () { return refresh(); });
  };
  S.cart.setQty = function (id, shade, qty) {
    var line = lines.filter(function (i) { return !i.isGift && i.id === id && i.shade === shade; })[0];
    if (!line) return;
    return request(ajaxRoute('cartChange', '/cart/change.js'), { id: line.key, quantity: Math.max(0, qty) }).then(function () { return refresh(); });
  };
  S.cart.remove = function (id, shade) { S.cart.setQty(id, shade, 0); };
  S.cart.freeShipRemaining = function () { return Math.max(0, S.FREE_SHIP - merchandiseSubtotal()); };
  S.cart.freeShipProgress = function () { return Math.min(1, merchandiseSubtotal() / S.FREE_SHIP); };

  /* keep the drawer honest once the real cart answers */
  var firstSync = true;
  document.addEventListener('vaire:cart-synced', function () {
    var n = document.getElementById('bagN');
    if (n) { n.textContent = S.cart.count() || ''; n.hidden = !S.cart.count(); }
    var drawer = document.getElementById('drawer');
    if (!firstSync && drawer && drawer.classList.contains('open') && window.VaireUI) window.VaireUI.openBag();
    firstSync = false;
  });

  refresh();
})();
